var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{staticClass:"icon-arrow-down",attrs:{"width":_vm.size + 'px',"fill":_vm.color,"viewBox":"0 0 104 51"}},[_c('path',{attrs:{"id":"Arrow_Down","data-name":"Arrow Down","d":"M51.3.687a1,1,0,0,1,1.4,0l49.552,48.6a1,1,0,0,1-.7,1.714H2.448a1,1,0,0,1-.7-1.714Z","transform":"translate(104 51) rotate(180)","fill":"#dae5ea"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }